import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const IconWrapper = styled(motion.div)<{
  theme: "light" | "dark";
  size: string;
  top: string;
  left: string;
}>`
  position: absolute;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  pointer-events: none;
  z-index: 1;
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const NeoBrutalistIcon = styled.div<{
  theme: "light" | "dark";
  bgColor: string;
}>`
  width: 100%;
  height: 100%;
  background: ${({ bgColor }) => bgColor};
  border: 4px solid
    ${({ theme }) => (theme === "light" ? "#000000" : "#ffffff")};
  box-shadow: ${({ theme }) =>
    theme === "light"
      ? "6px 6px 0px #000000"
      : "6px 6px 0px rgba(255, 255, 255, 0.3)"};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  transition: transform 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    color: ${({ theme }) => (theme === "light" ? "#000000" : "#ffffff")};
  }

  &:hover {
    transform: translate(3px, 3px);
    box-shadow: ${({ theme }) =>
      theme === "light"
        ? "3px 3px 0px #000000"
        : "3px 3px 0px rgba(255, 255, 255, 0.3)"};
  }
`;
